import React from "react";

export const Team = (props) => {
  const teamSize = props.data?.length || 0;

  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Project Owner / Founder</h2>
        </div>
        <div id="row" className="row">
          {props.data
            ? props.data.map((d, i) => {
                const colClass =
                  teamSize === 1
                    ? "col-md-4 col-md-offset-4 col-sm-6"
                    : "col-md-3 col-sm-6";
                return (
                  <div key={`${d.name}-${i}`} className={`${colClass} team`}>
                    <a href={props.data ? d.linkedinurl : "/"}>
                      <div className="thumbnail">
                        <img src={d.img} alt="..." className="team-img" />
                        <div className="caption">
                          <h4>{d.name}</h4>
                          <p>{d.job}</p>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
    </div>
  );
};
